import React from 'react'
import { MediaItem } from './types/dailyTaskRwo';

const MediaSummery = ({ media }: { media: MediaItem[] }) => {
  const counts = {
    total: media.length,
    pending: media.filter((m) => (m.status ?? "PENDING") === "PENDING").length,
    accepted: media.filter((m) => m.status === "APPROVED").length,
    rejected: media.filter((m) => m.status === "REJECTED").length,
  };

  return (
    <div className="grid grid-cols-4 gap-2 mb-5">
      {[
        {
          label: "Total",
          value: counts.total,
          cls: "text-gray-700 ",
          bg: "bg-gray-50 border-gray-100 ",
        },
        {
          label: "Pending",
          value: counts.pending,
          cls: "text-amber-600",
          bg: "bg-amber-50 border-amber-100 ",
        },
        {
          label: "Approved",
          value: counts.accepted,
          cls: "text-emerald-600",
          bg: "bg-emerald-50 border-emerald-100 ",
        },
        {
          label: "Rejected",
          value: counts.rejected,
          cls: "text-red-500",
          bg: "bg-red-50 border-red-100 ",
        },
      ].map(({ label, value, cls, bg }) => (
        <div
          key={label}
          className={`flex flex-col items-center py-3 rounded-xl border ${bg}`}
        >
          <span className={`text-lg font-black ${cls}`}>{value}</span>
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mt-0.5">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default MediaSummery